module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAcCAYAAADiHqZbAAAACXBIWXMAAAsSAAALEgHS3X78AAAAaUlEQVRYhe3XsQ2AMBQDUYOoEEshMQt7MCArIDagJULJRwkdpSsXvglee906IaDZPFTWMvZSuj0FrhzQUv0yjs04NuPYjGMzjs04NuPYjGMzjs04NuPYpHFtqo9Ha/rv8nkqblPDtYDzBVJkEfYX+mSBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blue/shapes/rect-red-b-2.png
// module id = 260
// module chunks = 0